import { ButtonVariant, IButtonProps } from '@amobee/component-library';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';
import { CampaignStatus } from 'src/app/data/constants/campaign-status.const';
import { MediaPlanStatus } from 'src/app/data/constants/mediaplan-status.const';
import { downloadExcelFile } from 'src/app/misc/util/util';
import { PacingReportData } from 'src/whiteLabel/mediaCorps/services/campaign/campaign-data';
import { environment } from '../../../../../../environments/environment';
import { MediaPlanVO } from '../../../../../data/vo/MediaPlanVO';

@Component({
    selector: 'campaign-running-status',
    templateUrl: './campaign-running-status.component.html',
    styleUrls: ['./campaign-running-status.component.scss']
})
export class CampaignRunningStatusComponent implements OnInit {

    @Input() campaignDetail: any;
    @Input() open: boolean = false;
    @Output() close = new EventEmitter();

    mediaPlan: MediaPlanVO;
    pacingReportData: PacingReportData;
    estimatedPlanStats: any;
    actualPlanStats: any;
    showPacingReporting: boolean = false;
    dataLoading: boolean = true;
    isLoadingPacingReportBlob: boolean;

    okButton: IButtonProps = {
        variant: ButtonVariant.PRIMARY,
        label: 'OK',
        onClick: () => {
            this.open = false;
            this.close.emit();
        }
    };
    campaignStatusConst = CampaignStatus;
    currencySymbol: string = environment.currency;
    currencyShortSymbol: string = environment.currencySymbol;
    timezoneStr: string = environment.timezone;
    timezoneAbbrStr: string = environment.timezoneAbbr;

    constructor(
        private campaignAdapter: CampaignAdapter
    ) {
    }

    ngOnInit() {
        if (this.campaignDetail) {
            if (this.campaignDetail.status === CampaignStatus.Running.key || this.campaignDetail.status === CampaignStatus.Completed.key) {
                this.campaignAdapter.getPacingReportData(this.campaignDetail.id).then(resp => {
                    this.pacingReportData = resp;
                    this.estimatedPlanStats = resp.summary && resp.summary.estimated_plan_stats;
                    this.actualPlanStats = resp.summary && resp.summary.actual_plan_stats;
                    if (this.estimatedPlanStats && this.estimatedPlanStats.demo_impressions && this.actualPlanStats && this.actualPlanStats.demo_impressions) {
                        this.showPacingReporting = true;
                        this.getMediaPlanData();
                    } else if (this.actualPlanStats && this.actualPlanStats.demo_impressions && this.estimatedPlanStats && !this.estimatedPlanStats.demo_impressions) {
                        this.getMediaPlanData(true);
                    } else {
                        this.showPacingReporting = false;
                        this.getMediaPlanData();
                    }
                }).catch((err) => {
                    console.log(err);
                    this.dataLoading = false;
                });
            } else {
                this.getMediaPlanData();
            }
        }
    }

    getMediaPlanData(updatePacingReporting = false) {
        this.campaignAdapter.getCampaignMediaPlan(this.campaignDetail.id).then(resp => {
            if (resp && resp.length > 0) {
                let plan = resp.find((mpVO: MediaPlanVO) => mpVO.status === MediaPlanStatus.APPROVED.key || mpVO.status === MediaPlanStatus.APPLIED.key || mpVO.status === MediaPlanStatus.REVIEW.key);
                if (!plan) {
                    // if there is no valid plan, pick the uploaded or the first one still
                    plan = resp[0];
                }
                if (updatePacingReporting) {
                    this.estimatedPlanStats = {
                        budget: plan.budget,
                        total_impressions: plan.totalImpressions,
                        demo_impressions: plan.demoImpressions,
                        demo_cpm: plan.demoCpm,
                        target_impressions: plan.targetImpressions,
                        target_cpm: plan.targetCpm
                    };
                    this.showPacingReporting = true;
                }
                this.mediaPlan = plan;
            } else {
                this.mediaPlan = null;
            }
            this.dataLoading = false;
        }).catch((err) => {
            console.log(err);
            this.dataLoading = false;
        });
    }

    cancel() {
        this.open = false;
        this.close.emit();
    }

    downloadPacingReportData() {
        if (this.campaignDetail) {
            this.isLoadingPacingReportBlob = true;
            this.campaignAdapter.downloadPacingReportData(this.campaignDetail.id).then((resp: Blob) => {
                downloadExcelFile(resp, 'PostCampaignReport.xlsx');
                console.log("Campaign pacing report downloaded");
            }).finally(() => {
                this.isLoadingPacingReportBlob = false;
            });
        }
    }
}
